export default __webpack_public_path__ + "static/media/footer.829c7c8f.less";